import { useDateTimeFormat } from "./useDateTimeFormat";
import { dateFormatOptions } from "./useFormatDate";

const partStr: Partial<
  Record<keyof Intl.DateTimeFormatPartTypesRegistry, string>
> = {
  day: "d",
  dayPeriod: "a",
  era: "G",
  hour: "h",
  minute: "m",
  month: "M",
  second: "s",
  weekday: "E",
  year: "y",
};

export function useDateFormatString(
  options: Intl.DateTimeFormatOptions = dateFormatOptions,
): string {
  const formatter = useDateTimeFormat(options);
  const formatToParts = formatter.formatToParts(new Date(2023, 11, 31));

  return formatToParts
    .map((part) => {
      if (part.type in partStr) {
        return "".padEnd(part.value.length, partStr[part.type]);
      } else if (part.type === "literal") {
        return part.value;
      } else {
        throw new Error("Unknown date format part type: " + part.type);
      }
    })
    .join("");
}

export const allDateTimeFormatOptions: Record<
  string,
  Intl.DateTimeFormatOptions
> = {
  fullDate: { year: "numeric", month: "long", day: "numeric", weekday: "long" },
  shortDate: { year: "numeric", month: "short", day: "numeric" },
  numericDate: { year: "numeric", month: "numeric", day: "numeric" },
  timeWithSeconds: { hour: "numeric", minute: "numeric", second: "numeric" },
  timeWithoutSeconds: { hour: "numeric", minute: "numeric" },
  fullDateTime: {
    year: "numeric",
    month: "long",
    day: "numeric",
    weekday: "long",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
  },
  shortDateTime: {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
  },
  numericDateTime: {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
  },
  weekdayOnly: { weekday: "long" },
  monthOnly: { month: "long" },
  yearOnly: { year: "numeric" },
  eraOnly: { era: "long" },
};
